import script from "./MembersManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./MembersManagement.vue?vue&type=script&setup=true&lang=js"

import "./MembersManagement.vue?vue&type=style&index=0&id=11dd8140&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11dd8140"]])

export default __exports__